import 'globals';

(function (PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if (objectFitVideos) {
            objectFitVideos();
        }
    });
})(window.PageLoadedQueue);
